import { createContext } from "react";
// eslint-disable-next-line import/no-unresolved
import { MenuPortalProps } from "react-select/dist/declarations/src/components/Menu";

export const MenuPortalPropsContext = createContext<Partial<MenuPortalProps<any, any, any>>>({})